import { WorkCenter } from "src/app/interfaces/base-entity";
import { GenericService } from "../../shared/services/generic.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class WorkCenterService extends GenericService<WorkCenter> {

  private baseUrl = `${environment.host}/api/WorkCenter`;

  constructor(http: HttpClient) {
    super(http);
    this.setApiUrl(this.baseUrl);
  }

  override update(id: number, entity: WorkCenter) {
    return this.http.put<WorkCenter>(`${this.baseUrl}/update`, {id, ...entity});
  }

  
}